import React from 'react';

import { FileTextOutlined, MailOutlined, MessageOutlined, PhoneOutlined, SyncOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { ACTIVITY_TYPE_SLUG } from './constants';

type ActivityTypeIconProps = {
  activityTypeSlug: string;
};

const Container = styled.div`
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 1px solid var(--line-gray);
  background: #fff;
  z-index: 1;
`;

const Icon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  font-size: 12px;
`;

const getActivityIcon = (activityTypeSlug: string) => {
  if (activityTypeSlug === ACTIVITY_TYPE_SLUG.EMAIL) {
    return <MailOutlined />;
  }

  if (activityTypeSlug === ACTIVITY_TYPE_SLUG.WEB_FORM_SUBMITTED) {
    return <FileTextOutlined />;
  }

  if (
    activityTypeSlug === ACTIVITY_TYPE_SLUG.PHONE_CALL ||
    activityTypeSlug === ACTIVITY_TYPE_SLUG.CALL_ATTEMPT ||
    activityTypeSlug === ACTIVITY_TYPE_SLUG.CALL_CONNECTED ||
    activityTypeSlug === ACTIVITY_TYPE_SLUG.VOICEMAIL
  ) {
    return <PhoneOutlined />;
  }

  if (activityTypeSlug === ACTIVITY_TYPE_SLUG.SMS) {
    return <MessageOutlined />;
  }

  if (activityTypeSlug === ACTIVITY_TYPE_SLUG.SHOP_REQUEST_STATUS_CHANGE) {
    return <SyncOutlined />;
  }

  return <MailOutlined />;
};

const ActivityTypeIcon = ({ activityTypeSlug }: ActivityTypeIconProps) => {
  return (
    <Container>
      <Icon>{getActivityIcon(activityTypeSlug)}</Icon>
    </Container>
  );
};

export default ActivityTypeIcon;
